// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedDrawArrow_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.2261 17.7416C8.95021 19.1531 11.1544 20 13.5565 20C19.0793 20 23.5565 15.5228 23.5565 10C23.5565 4.47715 19.0793 0 13.5565 0C8.03363 0 3.55648 4.47715 3.55648 10C3.55648 12.4005 4.4023 14.6035 5.81219 16.3271L0 22.1393L1.41421 23.5535L7.2261 17.7416ZM21.5565 10C21.5565 14.4183 17.9748 18 13.5565 18C11.707 18 10.0041 17.3724 8.64915 16.3185L13.435 11.5327L15.5563 13.654L15.5563 7.99714L9.8995 7.99714L12.0208 10.1185L7.23531 14.904C6.18304 13.5495 5.55648 11.8479 5.55648 10C5.55648 5.58172 9.1382 2 13.5565 2C17.9748 2 21.5565 5.58172 21.5565 10Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedDrawArrow is a generated icon component.
 */
let IconMedDrawArrow = IconMedDrawArrow_1 = class IconMedDrawArrow extends IconBaseElement {
    render() {
        return html `${IconMedDrawArrow_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedDrawArrow.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedDrawArrow = IconMedDrawArrow_1 = __decorate([
    customElement('zui-icon-med-draw-arrow')
], IconMedDrawArrow);
export { IconMedDrawArrow };
